module.exports = __webpack_public_path__ + "img/park-bg2.b21c91fd.png";